import { __ } from '@wordpress/i18n';

/**
 * Mobile menu setup
 *
 * Adds a class to the parent of deep menu items.
 * Adds a back button to deep menu items.
 *
 * @return {void}
 */
const mobileMenuSetup = () => {
  // Must add the class 'sub-menu-deep' to the parent of the deep menu items first
  const deepMenus = document.querySelectorAll(
    '.header__mobile-navigation .menu-item-has-children .menu-item-has-children',
  );
  if (deepMenus.length > 0) {
    deepMenus.forEach((deepMenu) => {
      deepMenu.parentElement.classList.add('sub-menu-deep');
    });
  }
  // Adds a back button as the first item in the deep menu
  const deepMenuFirstItems = document.querySelectorAll('.sub-menu-deep .sub-menu li:first-of-type');
  if (deepMenuFirstItems.length > 0) {
    deepMenuFirstItems.forEach((deepMenuFirstItem) => {
      const backArrow =
        '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="#FFF" fill-rule="evenodd" d="M7.13 11.974l4.473-4.756c.272-.29.715-.29.988 0s.273.76 0 1.05l-3.28 3.489h8.99c.386 0 .699.333.699.743s-.313.743-.699.743h-8.99l3.28 3.488c.273.29.273.761 0 1.051-.137.145-.315.218-.494.218-.18 0-.358-.073-.495-.218L7.13 13.026c-.273-.29-.273-.761 0-1.052z"></path></svg>';
      const backButton = `<button aria-label="go back">${backArrow}${__(
        'Back',
        'plarium',
      )}</button>`;
      deepMenuFirstItem.insertAdjacentHTML('beforebegin', backButton);
    });
  }
};

window.addEventListener('DOMContentLoaded', () => {
  mobileMenuSetup();
  const firstItem = document.querySelector('.header__mobile-navigation > ul > li:first-of-type');
  const mobileTabLinks = [...document.querySelectorAll('.header__mobile-navigation > ul > li > a')];
  const mobileMenuToggles = [...document.querySelectorAll('.header__mobile-menu button')];
  const header = document.querySelector('header.header');
  const mobileNav = document.querySelector('.header__mobile-navigation > ul');
  const deepMenuLinks = [...document.querySelectorAll('.sub-menu-deep > li.menu-item > a')];
  const deepMenuBackLinks = [...document.querySelectorAll('.sub-menu-deep button')];
  const mediaQueryDesktop = matchMedia('(min-width: 1024px)');

  /**
   * Close all open tabs
   *
   * @return {void}
   */
  const closeAllTabs = () => {
    mobileTabLinks.forEach((tabLink) => {
      tabLink.closest('.menu-item').classList.remove('menu-item--open');
    });
  };

  // Sets the first item in the mobile menu to open by default
  if (firstItem) {
    firstItem.classList.add('menu-item--open');
  }

  // Handle mobile menu toggles
  if (mobileMenuToggles.length > 0 && header) {
    mobileMenuToggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        header.classList.toggle('header--open');
      });
    });
  }

  // Handle mobile tab links
  if (mobileTabLinks.length > 0) {
    mobileTabLinks.forEach((tabLink) => {
      tabLink.addEventListener('click', (event) => {
        event.preventDefault();
        closeAllTabs();
        tabLink.closest('.menu-item').classList.add('menu-item--open');
      });
    });
  }

  // Handle window resize
  mediaQueryDesktop.addEventListener('change', (event) => {
    if (event.matches && header.classList.contains('header--open')) {
      header.classList.remove('header--open');
    }
  });

  // Handle deep menus
  if (deepMenuLinks.length > 0 && deepMenuBackLinks.length > 0) {
    deepMenuLinks.forEach((deepMenuLink) => {
      deepMenuLink.addEventListener('click', (event) => {
        event.preventDefault();
        const menuItem = deepMenuLink.closest('.menu-item');
        menuItem.classList.toggle('menu-item--open');
        mobileNav.classList.toggle('sub-menu-deep--open');
      });
    });
    deepMenuBackLinks.forEach((deepMenuBackLink) => {
      deepMenuBackLink.addEventListener('click', (event) => {
        event.preventDefault();
        const menuItem = deepMenuBackLink.closest('.menu-item');
        menuItem.classList.toggle('menu-item--open');
        mobileNav.classList.toggle('sub-menu-deep--open');
      });
    });
  }
});
